import type { Program, ProgramSeasonV1 } from '../../interface/Program';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const getV1ProgramSeasons = async (id: Program['id']) => {
  try {
    const { data } = await api.get<{ data: ProgramSeasonV1[] }>(
      apiConfig.routes.entertainment.program.v1.seasons(id)
    );

    return data.data;
  } catch {
    const { data } = await api.get<{ data: ProgramSeasonV1[] }>(
      apiConfig.routes.entertainment.program.v1.publicSeasons(id)
    );

    return data.data;
  }
};

export const useGetV1ProgramSeasons = (id: Program['id']) =>
  useQuery({
    queryKey: ['program', 'v1', id, 'seasons'],
    queryFn: () => getV1ProgramSeasons(id),
    enabled: !!id,
  });
